module.exports = __webpack_public_path__ + "static/CardOfDarkness2-0e0dbf30c52d69945fcc47c861415c3b.webp";